import { cn } from '@atrvd/saas-ui'
import type { TableSort } from './manualBankSort'

interface SortHeaderProps {
  label: string
  columnKey: string
  sort: readonly TableSort[]
}

/**
 * A sortable column's header text, emphasised while the table is sorted by it.
 * DataTable draws the direction arrow itself, as a sibling outside this node
 * and without a className hook, so only the label can be coloured here.
 */
export function SortHeader({ label, columnKey, sort }: SortHeaderProps) {
  const active = sort.some((s) => s.columnKey === columnKey)
  return <span className={cn(active && 'font-semibold text-primary')}>{label}</span>
}
